<template>
  <div>
    <h1>Déclaration du Chiffre d'affaires</h1>
    <div class="mode-emploi">
      <a v-if="selectedMember && selectedMember.Level == 3" href="/static/Documentation adherent saisie.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
      <a v-else href="/static/Documentation adherent resultats.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
    </div>
    <div class="d-flex justify-content-between">
      <SubstituteAdh :members="selectedMember && selectedMember.Level == 3 ? [selectedMember] : members" :selectedMemberGuid="selectedMemberGuid" @update="selectedMemberGuid = $event; onlyCdm = false"></SubstituteAdh>
      <button class="btn btn-success" @click="exportDatas">Exporter les données</button>
    </div>
    <br />
    <vue-good-table :columns="columns"
                    :rows="rows"
                    :sort-options="{enabled: true}"
                    :group-options="{enabled: true}">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'CaVenteN1' && selectedMember && selectedMember.Level == 3">
          <input class="form-control" type="number" v-model="modelsN1[props.row.Guid]" :placeholder="props.row[props.column.field]" @change="changedInput" />
        </span>
        <span v-else-if="props.column.field == 'CaVenteN' && selectedMember && selectedMember.Level == 3">
          <input class="form-control" type="number" v-model="modelsN[props.row.Guid]" :placeholder="props.row[props.column.field]" @change="changedInput" />
        </span>
        <span v-else-if="props.column.field == 'Changed' && selectedMember && selectedMember.Level == 3" class="btn-group">
          <button class="btn btn-success" v-if="props.row.Changed" @click="update"><font-awesome-icon icon="check"></font-awesome-icon></button>
          <button class="btn btn-danger" v-if="props.row.CaVenteN1 || props.row.CaVenteN" @click="deleteRow"><font-awesome-icon icon="trash"></font-awesome-icon></button>
        </span>
        <span v-else-if="props.column.field == 'Progression'">
          <span :class="{
                red: props.row[props.column.field] < 0,
                green: props.row[props.column.field] > 0
            }">
            {{props.formattedRow[props.column.field]}}
          </span>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  import SubstituteAdh from "@/components/SubstituteAdh";

  import { getAllMembersHierarchy } from "@/utils/member";
  import { getCaVente, updateCaVente } from "@/utils/caVente";
  import { getParameterByCode } from "@/utils/param";
  import { exportExcel } from "@/utils/exportExcel";

  export default {
    name: "CaVente",
    components: {
      SubstituteAdh
    },
    data() {
      return {
        selectedMemberGuid: "",
        members: [],
        caVenteData: [],
        rows: [{GroupeName: "Totaux", children: []}],
        modelsN1: {},
        modelsN: {},
        currentYear: -1
      }
    },
    mounted() {
      getParameterByCode("ANNEE_COURANTE").then(res => {
        this.currentYear = parseInt(res);
      })

      getAllMembersHierarchy().then(res => {
        this.members = res;
      })
    },
    watch: {
      selectedMember() {
        // Fetch data using this.selectedMember.Guid
        this.modelsN1 = {}
        this.modelsN = {}
        getCaVente(this.selectedMember.Level == 0 ? "" : this.selectedMember.Guid).then(res => {
          this.caVenteData = res;
          this.rows = this.computeRows();
        });
      }
    },
    computed: {
      me() {
        let minLevel = this.members.reduce((acc, el) => el.Level < acc ? el.Level : acc, 5)
        if (this.$store.state.self.isAdmin && minLevel === 1 && this.members.filter(el => el.Level === minLevel).length > 1) {
          minLevel = 0; // CMEM
        }
        return this.members.find(el => el.Level === minLevel) || ({ Name: "Admin", Level: 0, Label: "[A] Admin", Guid: "00000000-0000-0000-0000-000000000000" });
      },
      selectedMember() {
        if (!this.selectedMemberGuid) return this.me
        return this.members.find(el => el.Guid === this.selectedMemberGuid) || this.me
      },
      columns() {
        const res = [
          { label: "Groupe", field: "GroupeName", filterOptions: { enabled: true, } },
          { label: "Sous Groupe", field: "SousGroupeName", filterOptions: { enabled: true, } },
          { label: "Code Compta", field: "IdCompta", filterOptions: { enabled: true } },
          { label: "Société", field: "Name", filterOptions: { enabled: true } },
          { label: "Code Postal", field: "PostalCode", filterOptions: { enabled: true } },
          { label: "Ville", field: "City", filterOptions: { enabled: true } },
          { label: "CA " + (this.currentYear - 1), field: "CaVenteN1", type: "number", formatFn: this.formatNbEur, headerField: this.generateSumBy("CaVenteN1") },
          { label: "CA " + this.currentYear, field: "CaVenteN", type: "number", formatFn: this.formatNbEur, headerField: this.generateSumBy("CaVenteN")  },
          { label: "Progression %", field: "Progression", type: "number", formatFn: this.formatNbPercent, headerField: this.generateProgressionBy("CaVenteN1", "CaVenteN") },
          { label: "", field: "Changed" }
        ]

        if (this.selectedMember.Level < 3) return res.slice(0, res.length - 1)
        return [...res.slice(0, res.length - 2), ...res.slice(res.length - 1)];
      },
    },
    methods: {
      changedInput() {
        if (!this.selectedMember || this.selectedMember.Level != 3) return;
        const socGuid = this.selectedMember.Guid;
        const pdv = this.members.find(_m => _m.Level == 4 && _m.SocieteGuid == socGuid && /00S?$/.test(_m.IdCompta));
        const caVenteRow = pdv ? this.caVenteData.find(r => r.PdvGuid == pdv.Guid) : null;
        const caVenteN1 = caVenteRow ? caVenteRow.CaVenteN1 : 0;
        const caVenteN = caVenteRow ? caVenteRow.CaVenteN : 0;
        const modelN1 = this.modelsN1[socGuid] || caVenteN1;
        const modelN = this.modelsN[socGuid] || caVenteN;

        const changed = caVenteN1 != modelN1 || caVenteN != modelN
        this.rows[0].children = this.rows[0].children.map(r => {
          if (r.Guid == socGuid)
            r.Changed = changed;
          return r;
        })
        
      },
      computeRows() {
        if (!this.selectedMember || this.selectedMember.Level > 3) return [];
        const rows = this.members.filter(m => m.Level == 3 && (
          m.GroupeGuid == this.selectedMember.Guid ||
          m.SousGroupeGuid == this.selectedMember.Guid ||
          m.Guid == this.selectedMember.Guid ||
          this.selectedMember.Level == 0
        ))
          .map(m => {
            const pdv = this.members.find(_m => _m.Level == 4 && _m.SocieteGuid == m.Guid && /00S?$/.test(_m.IdCompta));
            const caVenteRow = pdv ? this.caVenteData.find(r => r.PdvGuid == pdv.Guid) : null;
            const caVenteN1 = caVenteRow ? caVenteRow.CaVenteN1 : 0;
            const caVenteN = caVenteRow ? caVenteRow.CaVenteN : 0;

            return {
              ...m,
              CaVenteN1: caVenteN1,
              CaVenteN: caVenteN,
              Progression: caVenteN == 0 ? 0 : ((caVenteN - caVenteN1) / caVenteN),
              CaVenteDeclared: caVenteRow != null,
              Changed: false
            }
          })
          .filter(r => this.selectedMember.Level == 3 || r.CaVenteDeclared)
          .sort((a, b) => {
            if (a.GroupeName < b.GroupeName) return -1
            else if (a.GroupeName > b.GroupeName) return 1
            else if (a.SousGroupeName < b.SousGroupeName) return -1
            else if (a.SousGroupeName > b.SousGroupeName) return 1
            else if (a.Name < b.Name) return -1
            else if (a.Name > b.Name) return 1
            else return -1;
          });
        return [{
          GroupeName: "Totaux",
          children: rows
        }]
      },
      update() {
        if (!this.selectedMember || this.selectedMember.Level !== 3) return;
        const socGuid = this.selectedMember.Guid;
        const row = this.rows[0].children.find(r => r.Guid == socGuid)
        const caVenteN1 = this.modelsN1[socGuid] || row.CaVenteN1;
        const caVenteN = this.modelsN[socGuid] || row.CaVenteN;

        updateCaVente(socGuid, caVenteN1, caVenteN).then(res => {
          this.modelsN1[socGuid] = undefined;
          this.modelsN[socGuid] = undefined;
          getCaVente(this.selectedMember.Level == 0 ? "" : this.selectedMember.Guid).then(res => {
            this.caVenteData = res;
            this.rows = this.computeRows();
          });
        })
      },
      deleteRow() {
        if (!this.selectedMember || this.selectedMember.Level !== 3) return;
        const validation = window.confirm("Voulez-vous vraiment supprimer cette saisie ?");
        if (!validation) return;
        const socGuid = this.selectedMember.Guid;

        updateCaVente(socGuid, 0, 0).then(res => {
          this.modelsN1[socGuid] = undefined;
          this.modelsN[socGuid] = undefined;
          getCaVente(this.selectedMember.Level == 0 ? "" : this.selectedMember.Guid).then(res => {
            this.caVenteData = res;
            this.rows = this.computeRows();
          });
        })
      },
      generateSumBy(field) {
        return function (rowObj) {
          return rowObj.children.reduce((acc, el) => ((el && el[field]) ? (el[field] + acc) : acc), 0);
        }
      },
      generateProgressionBy(fieldN, fieldNp1) { // Retourne une fonction de progression moyenne basée sur les champs de CA N - 1 et N envoyés en paramètres
        return function (rowObj) {
          const CaN = rowObj.children.reduce((acc, el) => el[fieldN] + acc, 0);
          const CaNp1 = rowObj.children.reduce((acc, el) => el[fieldNp1] + acc, 0);
          if (CaN == 0 && CaNp1 == 0) return 0;
          else if (CaN == 0) return 1;

          return ((CaNp1 - CaN) / CaN);
        }
      },
      formatNbEur(n) {
        return n.toLocaleString("fr-FR", { maximumFractionDigits: 0 });
      },
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
      exportDatas() { // Génère un export excel
        exportExcel(this.columns, this.rows[0].children, "Données CA Vente" + this.selectedMember.Name + " " + this.currentYear)
      },
    }
  }
</script>

<style scoped>
  .green {
    color: #30CC30 !important;
  }
  .red {
    color: #CC3030 !important;
  }
  .mode-emploi {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/CaVente.vue